import queryString from 'query-string';
import { useCallback } from 'react';
import { BASE_URL } from '../configs/config';
import { useSystemContext } from '../context/SystemContext/SystemContext';

const usePaymentMethod = () => {
  const { seatInfo, stadiumInfo } = useSystemContext();

  const payment = async (orderId: string) => {
    try {
      if (!stadiumInfo?.id || !seatInfo?.id) {
        throw new Error('PAYMENT_CONTEXT_MISSING');
      }

      const hostPath = window.location.origin;
      const orderDetailLink = queryString.stringifyUrl({
        url: `/orderdetail/${orderId}`,
        query: {
          seatID: seatInfo?.id,
          stadiumID: stadiumInfo?.id,
        },
      });
      const requestPayload = {
        orderId,
        frontUrl: `${hostPath}${orderDetailLink}`,
      };

      const response = await fetch(`${BASE_URL}start-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestPayload),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error || 'START_PAYMENT_FAILED');
      }

      return { ...data, payment_request_payload: requestPayload };
    } catch (error) {
      console.error('Error ', error);
      throw error;
    }
  };

  const checkPaymentStatus = useCallback(async (orderId: string) => {
    const response = await fetch(`${BASE_URL}payment-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ orderId }),
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.error || 'PAYMENT_STATUS_FAILED');
    }

    return data;
  }, []);

  return {
    payment,
    checkPaymentStatus,
  };
};

export default usePaymentMethod;
